import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { advisorMe, advisorLogin, advisorRegister, advisorGoogle, advisorLogout } from "../lib/api";

const AdvisorContext = createContext(null);
export const useAdvisor = () => useContext(AdvisorContext);

// Session lives in the HttpOnly hv_advisor cookie; the token is also held in memory (never storage) for iframe previews.
const setHeader = (token) => {
  if (token) axios.defaults.headers.common["X-Advisor-Token"] = token;
  else delete axios.defaults.headers.common["X-Advisor-Token"];
};

export const AdvisorProvider = ({ children }) => {
  const [advisor, setAdvisor] = useState(null); // null = checking, false = signed out

  const refresh = useCallback(async () => {
    try {
      setAdvisor(await advisorMe());
    } catch {
      setAdvisor(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — the callback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const finish = useCallback((res) => {
    setHeader(res.token);
    setAdvisor(res.advisor);
    return res.advisor;
  }, []);

  const value = {
    advisor,
    refresh,
    setAdvisor,
    login: async (payload) => finish(await advisorLogin(payload)),
    register: async (payload) => finish(await advisorRegister({ ...payload, beta_code: payload.beta_code || sessionStorage.getItem("hv_beta_code") || "" })),
    google: async (sessionId) => finish(await advisorGoogle(sessionId)),
    logout: async () => {
      await advisorLogout().catch(() => {});
      setHeader(null);
      setAdvisor(false);
    },
  };
  return <AdvisorContext.Provider value={value}>{children}</AdvisorContext.Provider>;
};
